export default "__VITE_ASSET__C9i9nK2G__"